import { render, staticRenderFns } from "./ParlayDesglose.vue?vue&type=template&id=535efad1&scoped=true&"
import script from "./ParlayDesglose.vue?vue&type=script&lang=js&"
export * from "./ParlayDesglose.vue?vue&type=script&lang=js&"
import style0 from "./ParlayDesglose.vue?vue&type=style&index=0&id=535efad1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535efad1",
  null
  
)

export default component.exports